export type { ResponsiveDevice } from "./IllustratedRouteLayout";
export { IllustratedRouteLayout } from "./IllustratedRouteLayout";
